import tw, { css } from 'twin.macro'

export const imgStyles = css`
  img {
    ${tw`rounded-t-4xl`}
  }
`
